import { Badge, Group, Tooltip } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getHarvestProofStatusConfig,
  HarvestProofStatusBadgeVariant,
} from '../../utils/harvest-proof-status-config';

import {
  HarvestProofFormStatus,
  HarvestProofParcelStatus,
} from '@harvest-proof/data-access';

export interface HarvestProofStatusBadgeProps {
  status: HarvestProofFormStatus | HarvestProofParcelStatus;
  variant?: HarvestProofStatusBadgeVariant;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const HarvestProofStatusBadge: FC<HarvestProofStatusBadgeProps> = ({
  status,
  variant = 'form',
  showLabel = true,
  size = 'sm',
}) => {
  const { t } = useTranslation();
  const config = getHarvestProofStatusConfig(status, variant);

  if (!config) {
    return null;
  }

  const Icon = config.icon;
  const label = t(config.labelKey);
  const tooltip = t(config.tooltipKey);

  return (
    <Tooltip label={tooltip} withArrow>
      <Badge
        color={config.color}
        leftSection={<Icon size={14} stroke={2} />}
        size={size}
        variant="light"
      >
        {showLabel ? label : null}
      </Badge>
    </Tooltip>
  );
};
